module.exports = __webpack_public_path__ + "img/24.bf1db4dd.svg";